import { AlkLogger, ETheme, setTheme } from '@alk/core';
import { CHANNEL_CONNECTOR_SERVICE, IChannelConnector } from '../channel-connector';
import { inject, injectable } from 'inversify';
import { IThemeService } from './theme.interface';

@injectable()
export class ThemeService implements IThemeService {

    @inject(CHANNEL_CONNECTOR_SERVICE) private readonly channelConnector: IChannelConnector;

    async init(): Promise<void> {
        try {
            const channel = await this.channelConnector.getChannel();
            channel.register('fnx-change-theme', ({ payload }) => {
                setTheme(payload as ETheme);
            });
        } catch (err) {
            AlkLogger.debug('[ThemeService#init] Error while trying to init the theme service.', err);
        }
    }
}
